const getImgUrl = (src: string) => {
    const value = src.toString();

    // All media lives under /wp-content/. Some add-on records have a corrupted
    // scheme/host (e.g. "htt/wp-content/..." or "https://wp-content/...") that,
    // once prefixed with the CDN host, yields an invalid hostname and crashes
    // next/image. Normalise to the clean path from /wp-content/ onward.
    const wpContentIndex = value.indexOf('/wp-content/');
    const imgPath =
        wpContentIndex !== -1
            ? value.slice(wpContentIndex)
            : // Fallback: strip any leading scheme+host so we never glue two
              // absolute URLs together. Keeps the path only.
              value.replace(/^https?:\/\/[^/]+/i, '');

    // Re-serve everything through the configured CDN host.
    return `${process.env.NEXT_PUBLIC_WORDPRESS_IMG_CDN_URL}${imgPath}`;
};

export default getImgUrl;
